import { useCallback, useEffect, useRef, useState } from "react";
import amsService from "../../../../../../../../../Service/OPSServices/StoreHealthServices/amsService.js";

const REFRESH_MS = 5 * 60 * 1000;

/** Loads overview, stores, subscriptions and button status for one UTC day. */
export default function useAmsData(date) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const latest = useRef(0);

  const load = useCallback(
    async (fresh = false) => {
      const call = ++latest.current;               // ignore answers to older requests
      setLoading(true);
      try {
        const [overview, stores, subscriptions, actions] = await Promise.all([
          amsService.getOverview(date, fresh),
          amsService.getStores(date, fresh),
          amsService.getSubscriptions(date, fresh),
          amsService.getActions(),
        ]);
        if (call !== latest.current) return;
        setData({ overview, stores, subscriptions, actions });
        setError(null);
      } catch (e) {
        if (call === latest.current) setError(e);
      } finally {
        if (call === latest.current) setLoading(false);
      }
    },
    [date]
  );

  useEffect(() => {
    load(false);
    const id = setInterval(() => {
      if (!document.hidden) load(false);
    }, REFRESH_MS);
    return () => clearInterval(id);
  }, [load]);

  return { data, loading, error, reload: load };
}
